import React, { useEffect, useRef, useState } from "react";
import NotificacionAuth from "../NotificacionAuth/NotificacionAuth";
import NotificacionEntity from "../../core/entities/notificacionEntity";
import style from "./UModalLogin.module.css";
import { fetchEnviarMensaje } from "./services/uModalContactanosService";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";

export default function UModalContactanos({
  vIsContactanos = false,
  mActivar_DesactivarModal = () => {},
}) {
  const notificacionRef = useRef(null);
  const [vIsCargandoResp, setvIsCargandoResp] = useState(false);
  const navigate = useNavigate(); // Hook para redirigir al usuario

  const [formData, setFormData] = useState({
    nombre: "",
    apellidos: "",
    correo: "",
    telefono: "",
    institucion: "",
    mensaje: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    mLimpiarDatos();
  }, [vIsContactanos]);

  const mLimpiarDatos = () => {
    setFormData({
      nombre: "",
      apellidos: "",
      correo: "",
      telefono: "",
      institucion: "",
      mensaje: "",
    });
  };

  const mValidarDatos = () => {
    const { nombre, apellidos, correo, telefono, institucion, mensaje } =
      formData;

    if (nombre.trim().length === 0) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Error en Nombre",
          "Por favor, ingresa tu nombre.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (apellidos.trim().length === 0) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Error en Apellidos",
          "Por favor, ingresa tus apellidos.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (correo.trim().length === 0) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Error en Correo",
          "Por favor, ingresa tu correo electrónico.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(correo)) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Formato de Correo Incorrecto",
          "El correo ingresado no es válido.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (telefono.trim().length === 0) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Error en Teléfono",
          "Por favor, ingresa tu número de teléfono.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (!/^\d{10,12}$/.test(telefono)) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Formato de Teléfono Incorrecto",
          "El teléfono debe tener entre 10 y 12 dígitos numéricos.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (institucion.trim().length === 0) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Error en Institución",
          "Por favor, ingresa el nombre de tu institución.",
          "rojo",
          15
        )
      );
      return false;
    }

    if (mensaje.trim().length === 0) {
      notificacionRef.current.show(
        new NotificacionEntity(
          "Error en Mensaje",
          "Por favor, ingresa un mensaje.",
          "rojo",
          15
        )
      );
      return false;
    }

    return true; // ✅ Si todo está correcto, retorna true
  };

  const mHanddleEnviar = () => {
    if (mValidarDatos()) {
      notificacionRef.current.hide();
      setvIsCargandoResp(true);

      fetchEnviarMensaje(formData) // contactoData contiene nombre, correo, mensaje, etc.
        .then(async (response) => {
          setvIsCargandoResp(false);

          if (response.ok) {
            const result = await response.json();
            mLimpiarDatos();
            notificacionRef.current.show(
              new NotificacionEntity(
                "Mensaje enviado",
                "Tu mensaje ha sido enviado con éxito. Nos pondremos en contacto pronto.",
                "verde",
                5
              )
            );
            setTimeout(() => {
              mActivar_DesactivarModal("", false);
            }, 5000);
            return result;
          }

          // Manejo de diferentes tipos de errores basados en el código de estado
          const errorData = await response.json();

          switch (response.status) {
            case 400:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Solicitud incorrecta",
                  "Por favor, revisa los datos ingresados.",
                  "amarillo",
                  10
                )
              );
              return;

            case 404:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Servicio no disponible",
                  "No pudimos encontrar el servicio de contacto. Inténtalo más tarde.",
                  "amarillo",
                  10
                )
              );
              throw new Error("ERR_ME");

            case 500:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Error del servidor",
                  "Ocurrió un problema al procesar tu solicitud. Inténtalo más tarde.",
                  "rojo",
                  10
                )
              );
              throw new Error("ERR_ME");

            default:
              notificacionRef.current.show(
                new NotificacionEntity(
                  "Error desconocido",
                  "Ocurrió un error inesperado. Inténtalo más tarde.",
                  "rojo",
                  10
                )
              );
              throw new Error("ERR_ME");
          }
        })
        .catch((error) => {
          if (error.message !== "ERR_ME") {
            notificacionRef.current.show(
              new NotificacionEntity(
                "Error de red",
                "No se pudo conectar con el servidor. Verifica tu conexión.",
                "rojo",
                10
              )
            );
          }
        })
        .finally(() => {
          setvIsCargandoResp(false);
        });
    }
  };

  if (!vIsContactanos) {
    return null;
  }

  return (
    <div class="box-modals-publico">
      <div class="contactanos">
        <div class="contactanos-info-1-2">
          <div class="contactanos-titulos-3">
            <div class="contactanos-titulo-1-3">Contáctanos</div>
            <div class="contactanos-titulo-2-3">
              Completa el formulario y nos comunicaremos contigo a la brevedad
            </div>
          </div>
          <div class="contactanos-whatsapp-3">
            <i class="fi fi-rs-circle-phone-flip whatsapp-2"></i>
            <div class="contactanos-whatsapp-texto-3">
              +52 55 6894 0926
              <br />
              +52 55 6894 0925
            </div>
          </div>
          <div class="contactanos-whatsapp-3">
            <i class="fi fi-rs-envelope whatsapp-2"></i>

            <div class="contactanos-whatsapp-texto-3">contacto@mhm.com.mx</div>
          </div>
        </div>
        <div class="contactanos-info-2-4">
          <NotificacionAuth
            ref={notificacionRef} // Usando la referencia
          />
          <div class="contactanos-titulos-3-movil">
            <div class="contactanos-titulo-1-3">Contáctanos</div>
            <div class="contactanos-titulo-2-3">
              Completa el formulario y nos comunicaremos contigo a la brevedad
            </div>
          </div>
          <div class="contactanos-info-3">
            <div class="contactanos-apartados-2">
              <div class="contactanos-apartado-1-4">
                <div data-figma-id="933:13808" class="correo-11">
                  <p data-figma-id="933:13809" class="correo-titulo-3">
                    Nombre(s)*
                  </p>
                  <input
                    id="modal_publico"
                    type="text"
                    data-figma-id="933:13810"
                    class={`correo-ejemplo-3 ${style.input}`}
                    name="nombre"
                    placeholder="Nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    onKeyDown={(e) => e.key === "Enter" && mHanddleEnviar()}
                  />
                </div>
                <div data-figma-id="933:13808" class="correo-11">
                  <p data-figma-id="933:13809" class="correo-titulo-3">
                    Apellidos*
                  </p>

                  <input
                    id="modal_publico"
                    type="text"
                    data-figma-id="933:13810"
                    class="correo-ejemplo-3"
                    name="apellidos"
                    placeholder="Apellidos"
                    value={formData.apellidos}
                    onChange={handleChange}
                    onKeyDown={(e) => e.key === "Enter" && mHanddleEnviar()}
                  />
                </div>
              </div>
              <div class="contactanos-apartado-1-4">
                <div data-figma-id="933:13808" class="correo-11">
                  <p data-figma-id="933:13809" class="correo-titulo-3">
                    Correo Electrónico*
                  </p>

                  <input
                    id="modal_publico"
                    type="mail"
                    data-figma-id="933:13810"
                    class="correo-ejemplo-3"
                    name="correo"
                    placeholder="Correo"
                    value={formData.correo}
                    onChange={handleChange}
                    onKeyDown={(e) => e.key === "Enter" && mHanddleEnviar()}
                  />
                </div>
                <div data-figma-id="933:13808" class="correo-11">
                  <p data-figma-id="933:13809" class="correo-titulo-3">
                    Teléfono*
                  </p>
                  <input
                    id="modal_publico"
                    type="tel"
                    data-figma-id="933:13810"
                    class="correo-ejemplo-3"
                    name="telefono"
                    placeholder="Teléfono"
                    value={formData.telefono}
                    onChange={handleChange}
                    onKeyDown={(e) => e.key === "Enter" && mHanddleEnviar()}
                  />
                </div>
              </div>
              <div data-figma-id="933:13808" class="correo-11">
                <p data-figma-id="933:13809" class="correo-titulo-3">
                  Institución*
                </p>
                <input
                  id="modal_publico"
                  type="text"
                  data-figma-id="933:13810"
                  class="correo-ejemplo-3"
                  name="institucion"
                  placeholder="Institución"
                  value={formData.institucion}
                  onChange={handleChange}
                  onKeyDown={(e) => e.key === "Enter" && mHanddleEnviar()}
                />
              </div>
              <div class="mensaje">
                <div class="contactanos-titulo-2-3">Mensaje*</div>
                <textarea
                  id=""
                  rows="10"
                  name="mensaje"
                  placeholder="Escribe tu mensaje aquí..."
                  value={formData.mensaje}
                  onChange={handleChange}
                  class={`correo-ejemplo-5 ${style.textarea}`}
                ></textarea>
              </div>
            </div>
            <div data-figma-id="933:13464" class="login-botones-2">
              <div
                data-figma-id="933:13821"
                class="boton-cancelar-2"
                onClick={() => mActivar_DesactivarModal("", false)}
              >
                <p data-figma-id="933:13822" class="boton-cancelar-texto-2">
                  Cancelar
                </p>
              </div>
              <div
                data-figma-id="933:13823"
                class="boton-login"
                onClick={mHanddleEnviar}
                style={
                  vIsCargandoResp
                    ? { cursor: "wait", backgroundColor: "#1D90F5" }
                    : {}
                }
              >
                {vIsCargandoResp ? (
                  <ThreeDots
                    height="30"
                    width="30"
                    color="#fff"
                    radius="1"
                    ariaLabel="three-dots-loading"
                  />
                ) : (
                  <p data-figma-id="933:13824" class="boton-login-texto">
                    Enviar
                  </p>
                )}
              </div>
            </div>
          </div>
          <div class="contactanos-texto-3">
            Los campos con * son obligatorios
          </div>
        </div>
      </div>
    </div>
  );
}
